import {
  LayoutDashboard,
  Radio,
  UserRound,
  Users,
  Plus,
  ListChecks,
  PhoneCall,
  Upload,
  Megaphone,
  Phone,
  LineChart,
  Calendar,
  BarChart3,
  Settings,
  ScrollText,
  BellRing,
  Tag,
  ListOrdered,
  MapPin,
  Layers,
  FileText,
  DatabaseBackup,
  Activity,
  HelpCircle,
  TrendingUp,
  Shield,
  Target,
  type LucideIcon,
} from 'lucide-vue-next'

export interface NavItem {
  label: string
  to?: string
  icon: LucideIcon
  permission?: string
  external?: boolean
  children?: Array<{ label: string; to: string; permission?: NavItem['permission'] }>
}

export const navItems: NavItem[] = [
  {
    label: 'Dashboard Supervisor',
    to: '/dashboard/supervisor',
    icon: LayoutDashboard,
    permission: 'dashboard:view_supervisor',
  },
  {
    label: 'Mi Dashboard',
    to: '/dashboard/operator',
    icon: UserRound,
    permission: 'dashboard:view_operator',
  },
  {
    label: 'Leads',
    icon: Users,
    children: [
      { label: 'Ver Todos', to: '/leads', permission: 'leads:read' },
      { label: 'Nuevo Lead', to: '/leads/new', permission: 'leads:create' },
      { label: 'Mis Asignados', to: '/my/leads', permission: 'leads:read' },
      { label: 'Mis Callbacks', to: '/my/callbacks', permission: 'leads:read' },
      { label: 'Mis Llamadas', to: '/calls', permission: 'call_logs:read' },
      { label: 'Importar CSV', to: '/leads/import', permission: 'leads:import' },
    ],
  },
  {
    label: 'Campañas',
    to: '/campaigns',
    icon: Megaphone,
    permission: 'campaigns:view',
  },
  {
    label: 'Centralita',
    to: '/centralita',
    icon: PhoneCall,
    permission: 'dashboard:view_live',
    external: true,
  },
  {
    label: 'Mis Leads',
    to: '/generator/dashboard',
    icon: TrendingUp,
    permission: 'generator:view_own_leads',
  },
  {
    label: 'Calendario',
    to: '/calendar',
    icon: Calendar,
    permission: 'calendar:read',
  },
  {
    label: 'Analytics',
    icon: BarChart3,
    permission: 'analytics:view',
    children: [
      { label: 'Reportes Generales', to: '/analytics', permission: 'analytics:view' },
      { label: 'Cuadro de Mando Leads', to: '/cuadro-mando/leads', permission: 'analytics:view_leads' },
    ],
  },
  {
    label: 'Administración',
    icon: Settings,
    permission: 'admin:settings:read',
    children: [
      { label: 'Usuarios', to: '/users', permission: 'admin:users:read' },
      { label: 'Configuración', to: '/admin/settings', permission: 'admin:settings:read' },
      { label: 'Logs de Auditoría', to: '/admin/audit', permission: 'admin:audit:read' },
      { label: 'Recordatorios Callback', to: '/admin/callback-reminders', permission: 'admin:callback_reminders:read' },
      { label: 'Resultados de Llamada', to: '/admin/call-results', permission: 'admin:call_results:read' },
      { label: 'Estados de Lead', to: '/admin/lead-statuses', permission: 'admin:lead_status:read' },
      { label: 'Zonas', to: '/zonas', permission: 'admin:zonas:read' },
      { label: 'Tarifas', to: '/tarifas', permission: 'tariffs:read' },
      { label: 'Plantillas', to: '/admin/templates', permission: 'admin:templates:read' },
      { label: 'Retención de Datos', to: '/admin/retention', permission: 'admin:retention:read' },
      { label: 'Monitorización', to: '/admin/system', permission: 'admin:system:view' },
      { label: 'Roles', to: '/admin/roles', permission: 'admin:rbac' },
      { label: 'Permisos', to: '/admin/permissions', permission: 'admin:rbac' },
    ],
  },
  {
    label: 'Ayuda',
    icon: HelpCircle,
    children: [
      { label: 'Guía de usuario', to: '/help' },
      {
        label: 'Reiniciar tours',
        to: '#reset-tours',
      },
    ],
  },
]

export const operatorStatuses = [
  { value: 'available', label: 'Disponible', color: 'bg-emerald-500' },
  { value: 'on_call', label: 'En Llamada', color: 'bg-blue-500' },
  { value: 'break', label: 'En Pausa', color: 'bg-amber-500' },
  { value: 'backoffice', label: 'Backoffice', color: 'bg-slate-400' },
  { value: 'offline', label: 'Desconectado', color: 'bg-rose-500' },
] as const
